<template>
  <!-- <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="2 2 20 20"  fill="white">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
  </svg> -->

  <svg width="28" height="29" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.8333 9.79833C18.56 10.6617 19.75 12.435 19.75 14.5C19.75 14.7567 19.7267 15.0017 19.6917 15.235L16.8333 12.3767V9.79833Z" fill="white"/>
    <path d="M22.0367 17.58C22.4333 16.6233 22.6667 15.5967 22.6667 14.5C22.6667 10.8017 20.205 7.675 16.8333 6.67167V4.26833C21.5117 5.33 25 9.50667 25 14.5C25 16.25 24.5683 17.895 23.7983 19.3417L22.0367 17.58Z" fill="white"/>
    <path d="M4 5.48167L5.48167 4L14.5 13.0183L25 23.5183L23.5183 25L21.1383 22.6083C19.9017 23.6117 18.4433 24.3583 16.8333 24.72V22.3167C17.8017 22.025 18.6767 21.5467 19.4583 20.94L14.5 15.9817V23.8333L8.66667 18H4V11H9.51833L4 5.48167Z" fill="white"/>
    <path d="M12.0617 7.605L14.5 5.16667V10.0433L12.0617 7.605Z" fill="white"/>
  </svg>

</template>

<script>

export default {
  data() {
    return {
      fill: '#E0E1E2',
    }
  },
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/fanClub/notes/svg/SoundMute.vue